import { render, staticRenderFns } from "./ed-modal-message.vue?vue&type=template&id=1cc3ba32&scoped=true&"
import script from "./ed-modal-message.ts?vue&type=script&lang=js&"
export * from "./ed-modal-message.ts?vue&type=script&lang=js&"
import style0 from "./ed-modal-message.scss?vue&type=style&index=0&id=1cc3ba32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc3ba32",
  null
  
)

export default component.exports